<template>
  <div>
    <a-card :bordered="false" title="利润表">
      <div class="period-bar">
        <a-button size="small" icon="left" @click="shiftPeriod(-1)" />
        <span class="period-text">{{ periodLabel }}</span>
        <a-button size="small" icon="right" @click="shiftPeriod(1)" />
        <a-month-picker style="margin-left: 12px;" :value="periodMoment" format="YYYY-MM" :allowClear="false" @change="onPeriodChange" />
        <span style="margin-left: 12px; display: inline-block; width: 180px;">
          <store-tenant-select domain="finance" @change="handleStoreTenantChange"></store-tenant-select>
        </span>
        <a-button style="margin-left: 12px;" icon="reload" @click="searchQuery">刷新</a-button>
        <a-button class="float-right" icon="setting" @click="editItems">编辑数据项</a-button>
      </div>
      <a-spin :spinning="loading">
        <div class="scroll-wrap" :style="{ maxHeight: scrollHeight + 'px', overflowY: 'auto' }">
        <table class="cf-table">
          <thead>
            <tr>
              <th>项目</th>
              <th class="cf-rowno">行次</th>
              <th class="cf-amt">{{ columns[0] }}</th>
              <th class="cf-amt">{{ columns[1] }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(it, idx) in displayRows">
              <tr v-if="it.row.isGroup === '1'" :key="'g' + idx" class="cf-group">
                <td :colspan="4" :style="indentStyle(it.row)">
                  <a-icon v-if="it.row.folded === '1' && it.hasChildren" :type="foldIcon(it.row)" class="fold-toggle" @click="toggleFold(it.row.id)" />
                  <span :class="{ 'cf-bold': it.row.bold === '1' }">{{ it.row.name }}</span>
                </td>
              </tr>
              <tr v-else :key="'r' + it.row.id" :class="{ 'cf-bold': it.row.bold === '1' }">
                <td :style="indentStyle(it.row)">
                  <a-icon v-if="it.row.folded === '1' && it.hasChildren" :type="foldIcon(it.row)" class="fold-toggle" @click="toggleFold(it.row.id)" />
                  {{ it.row.name }}
                </td>
                <td class="cf-rowno">{{ it.row.rowNo }}</td>
                <td class="cf-amt" :class="{ neg: isNeg(it.row.amount1) }">{{ fmtAmount(it.row.amount1) }}</td>
                <td class="cf-amt" :class="{ neg: isNeg(it.row.amount2) }">{{ fmtAmount(it.row.amount2) }}</td>
              </tr>
            </template>
            <tr v-if="!loading && !displayRows.length">
              <td colspan="4" style="text-align: center; color: #999;">暂无数据</td>
            </tr>
          </tbody>
        </table>
        </div>
      </a-spin>
      <div v-if="checks.length" style="margin-top: 12px;">
        <div style="font-weight: 600; margin-bottom: 4px;">勾稽校验</div>
        <div v-for="(c, i) in checks" :key="'ck' + i" style="line-height: 22px;">
          <span :class="c.ok ? 'cf-ok' : 'neg'">{{ c.ok ? '√' : '×' }}</span> {{ c.name }}<template v-if="!c.ok">（预期 {{ fmtCheck(c.expected) }} / 实际 {{ fmtCheck(c.actual) }}）</template>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import { ledgerProfit, accountSetCurrent } from './api'
import StoreTenantSelect from '@/components/StoreTenantSelect'
export default {
  name: 'ProfitStatementList',
  components: { StoreTenantSelect },
  data() {
    return {
      accountSetId: null,
      period: moment().format('YYYY-MM'),
      loading: false,
      scrollHeight: 400,
      standard: '',
      columns: ['本年累计金额', '本期金额'],
      rows: [],
      checks: [],
      expandedKeys: new Set()
    }
  },
  computed: {
    periodLabel() {
      const m = moment(this.period, 'YYYY-MM')
      if (!this.period || !m.isValid()) return this.period || ''
      return m.format('YYYY') + '年第' + m.format('MM') + '期'
    },
    periodMoment() {
      return this.period ? moment(this.period, 'YYYY-MM') : null
    },
    displayRows() {
      return this.buildDisplay(this.rows)
    }
  },
  created() { this.loadCurrent() },
  mounted() {
    this.$nextTick(() => {
      const el = this.$el.querySelector('.scroll-wrap')
      if (el) {
        const top = el.getBoundingClientRect().top
        this.scrollHeight = Math.max(300, window.innerHeight - top - 24)
      }
    })
  },
  methods: {
    loadCurrent() {
      accountSetCurrent({}).then((res) => {
        if (res && res.success && res.data && res.data.id) {
          this.accountSetId = res.data.id
          this.searchQuery()
        } else { this.$message.warning('尚未建账或未设当前账套') }
      })
    },
    shiftPeriod(dir) {
      this.period = moment(this.period, 'YYYY-MM').add(dir, 'month').format('YYYY-MM')
      this.searchQuery()
    },
    handleStoreTenantChange() {
      this.searchQuery()
    },
    onPeriodChange(m) {
      if (!m) return
      this.period = m.format('YYYY-MM')
      this.searchQuery()
    },
    searchQuery() {
      if (!this.accountSetId || !this.period) return
      this.loading = true
      ledgerProfit({ accountSetId: this.accountSetId, period: this.period }).then((res) => {
        if (res && res.success && res.data) {
          this.standard = (res.data.meta && res.data.meta.standard) || ''
          this.columns = (res.data.meta && res.data.meta.columns) || ['本年累计金额', '本期金额']
          this.rows = res.data.rows || []
          this.checks = res.data.checks || []
        } else {
          if (res && !res.success && res.message) this.$message.warning(res.message)
          this.standard = ''
          this.rows = []
          this.checks = []
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    /** 折叠可见行计算：栈记录未展开折叠行的层级，其后更深连续行隐藏；同时标记各行是否有子级 */
    buildDisplay(rows) {
      const out = []
      const collapsed = []
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i]
        while (collapsed.length && collapsed[collapsed.length - 1] >= row.level) collapsed.pop()
        if (collapsed.length) continue
        const hasChildren = i + 1 < rows.length && rows[i + 1].level > row.level
        out.push({ row: row, hasChildren: hasChildren })
        if (row.folded === '1' && hasChildren && !this.expandedKeys.has(row.id)) collapsed.push(row.level)
      }
      return out
    },
    indentStyle(row) {
      return { paddingLeft: ((row.level || 0) * 15 + 8) + 'px' }
    },
    foldIcon(row) {
      return this.expandedKeys.has(row.id) ? 'down' : 'right'
    },
    toggleFold(id) {
      const keys = new Set(this.expandedKeys)
      if (keys.has(id)) keys.delete(id)
      else keys.add(id)
      this.expandedKeys = keys
    },
    fmtAmount(v) {
      if (v === null || v === undefined || v === '') return ''
      return Number(v).toFixed(2)
    },
    isNeg(v) {
      return v !== null && v !== undefined && v !== '' && Number(v) < 0
    },
    fmtCheck(v) {
      if (v === null || v === undefined || v === '') return '—'
      return Number(v).toFixed(2)
    },
    editItems() {
      this.$router.push({ path: '/plugin/gledger/reportItem/profit', query: { standard: this.standard } })
    }
  }
}
</script>

<style scoped>
.period-bar { margin-bottom: 12px; }
.period-text { display: inline-block; min-width: 110px; text-align: center; font-weight: 600; }
.float-right { float: right; }
.scroll-wrap { overflow-x: auto; }
.cf-table { width: 100%; border-collapse: collapse; }
.cf-table th, .cf-table td { border: 1px solid #e8e8e8; padding: 8px 12px; }
.cf-table th { background: #fafafa; font-weight: 600; }
.cf-rowno { width: 60px; text-align: center; }
.cf-amt { width: 130px; text-align: right; }
.cf-group td { font-weight: 600; background: #fafafa; }
.cf-bold { font-weight: 600; }
.neg { color: #f5222d; }
.cf-ok { color: #52c41a; }
.fold-toggle { margin-right: 4px; color: #1890ff; cursor: pointer; }
</style>
